export enum AvailableRoutes {
  UNAUTHORIZED = 'unauthorized',

  ADMIN = 'admin',

  DEPLOYMENTS = 'deployments',
  GNB_CUSTOM_CONFIGURATION = 'gnb-custom-configuration',
  NEW_DEPLOYMENT = 'new-deployment',
  UPDATE_DEPLOYMENT = 'update-deployment',
  GNB_DEFAULT_CONFIGURATION = 'gnb-default-configuration',

  LICENSES = 'licenses',

  RELEASES = 'releases',
  NEW_RELEASE = 'new-release',

  USERS = 'users',
  NEW_USER = 'new-user',

  STOCK = 'stock',
  STOCK_MACHINES = 'machines',
  ADD_MACHINE = 'add-machine',
  SETUP = 'setup',
  QUALITY_ASSURANCE = 'quality-assurance',
  TO_SHIP = 'to-ship',
  SHIPPED = 'shipped',

  OPERATIONS = 'operations',
  ORDERS = 'orders',
}
